<script>
import {getText} from "@/utils/text";

export default {
  data() {
    return {
    }
  },
  methods: {
    getViewText(key) {
      return getText(key)
    }
  }
}
</script>

<template>
  <div>
    <section id="paymentSecurity"
             class="payment-security sm:payment-security-sm md:payment-security-md lg:payment-security-lg xl:payment-security-xl">
      <div class="my-4 md:my-6">
        <div class="flex justify-center max-w-[920px] mx-auto">
          <div class="">
            <div
              style="font-size:17.0pt;"
              class="section-heading both-side-border relative sm:heading-size-17-sm md:heading-size-1-md lg:heading-size-1-lg">
              {{ getViewText('foot_tip_1') }}
            </div>
          </div>
        </div>
        <div class="mycontainer">
          <div class="payments lg:flex lg:justify-center lg:items-start">
            <div class="lg:mx-auto">
              <div class="sub-heading sm:text-size-1 md:text-size-1 lg:text-size-3">
                {{ getViewText('foot_tip_2') }}
              </div>
              <div class="payments_div_1">
                <div class="payment-icons-container payments_div_3 flex flex-wrap items-center gap-4">

                  <!-- <img alt="googlePay" src="../assets/img/pament/googlePay.png"
                       class="payment-icon md:h-[26px] lg:h-[26px]"
                       loading="lazy"> -->

                  <img alt="paytem" src="../assets/img/pament/paytm.png"
                       class="payment-icon md:h-[26px] lg:h-[26px]"
                       loading="lazy">

<!--                  <img alt="phonepe" src="../assets/img/pament/phonepe.png"-->
<!--                       class="payment-icon md:h-[26px] lg:h-[26px]"-->
<!--                       loading="lazy">-->

                  <img alt="billdesk" src="../assets/img/pament/billdesk.png"
                       class="payment-icon md:h-[26px] lg:h-[26px]"
                       loading="lazy">

                  <img alt="tech process" src="../assets/img/pament/techprocess.png"
                       class="payment-icon md:h-[26px] lg:h-[26px]"
                       loading="lazy">

                  <img alt="UPI" src="../assets/img/pament/upi.png"
                       class="payment-icon md:h-[26px] lg:h-[26px]"
                       loading="lazy">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="bottomPolicy">
      <div class="line"></div>
      <div class="websitexplain">{{ getViewText('foot_copyright') }}</div>
      <div class="policy">
        <ul class="clearfix">
          <li class="item1">
            <router-link :to="{ name: 'contactus' }">{{ getViewText('contact_us') }}</router-link>
          </li>
          <li class="item3">
            <router-link :to="{ name: 'termsconditions' }">T & C</router-link>
          </li>
          <li class="item5">
            <router-link :to="{ name: 'privacypolicy' }">{{ getViewText('privacy_policy') }}</router-link>
          </li>
          <li class="item7">
            <router-link :to="{ name: 'refundpolicy' }">{{ getViewText('refund_policy') }}</router-link>
          </li>
        </ul>
      </div>

    </section>
  </div>
</template>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/foot.vue